import Vue from 'vue';
import Router from 'vue-router';

import IndexPage from '@/components/Index';

import ExChange from '@/components/exChange/ExChange';
import ExChangeRateHistory from '@/components/exChange/RateHistory';
import ExChangeTaxRefund from '@/components/exChange/TaxRefund';

import WeatherCityList from '@/components/weather/CityList.vue';
import WeatherTenki from '@/components/weather/Tenki.vue';

import QueueIndex from '@/components/queue/Index';
import QueueWaitTime from '@/components/queue/WaitTime';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'TmpIndex',
      component: IndexPage,
      meta: {
        title: '日本旅游案内'
      }
    }, {
      path: '/exchange',
      name: 'ExChange',
      component: ExChange,
      meta: {
        title: '汇率案内'
      }
    }, {
      path: '/exchange/rate-history',
      name: 'RateHistory',
      component: ExChangeRateHistory,
      meta: {
        title: '汇率案内 - 日元汇率'
      }
    }, {
      path: '/exchange/tax-refund',
      name: 'TaxRefund',
      component: ExChangeTaxRefund,
      meta: {
        title: '汇率案内 - 日本购物退税攻略'
      }
    }, {
      path: '/weather',
      name: 'Weather',
      component: WeatherCityList,
      meta: {
        title: '天气案内'
      }
    }, {
      path: '/weather/tenki/:id',
      name: 'Tenki',
      component: WeatherTenki,
      meta: {
        title: '天气案内'
      }
    }, {
      path: '/queue',
      name: 'Queue',
      component: QueueIndex,
      meta: {
        title: '排队案内'
      }
    }, {
      path: '/queue/waittime/:place',
      name: 'WaitTime',
      component: QueueWaitTime,
      meta: {
        title: '排队案内'
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js